import { store } from "../../store";
import { LoginActions } from "../../store/ducks/application/login/login";

export async function isWifi() {

    const conn =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

    if (!conn) return false;

    store.dispatch(LoginActions.ConnectionType(`${conn?.type}`));

    if (conn?.type === "wifi")
        return true;

    let response = await fetch(process.env.REACT_APP_NETWORK_DETECTION_SERVICE);

    if (!response.ok) return false;

    const data = await response.json();

    console.log('Dados recebidos:', data);

    return data.isInternal;
}